import { useMemo } from 'react';
import { convertDateToStringFormat, lastDateOfMonth } from '@bloomays-lib/utils.shared';

import { CRAStatus, InvoiceStatus } from '@bloomays-lib/types.shared';
import { ActionButton } from '@bloomays-lib/ui.shared';

type CraRelaunchActionProps = {
  missionId: string;
  activityId?: string;
  CRAStatus: CRAStatus;
  validated?: boolean;
  billed?: boolean;
  signingDocumentId?: string;
  clientInvoiceStatus?: InvoiceStatus;
  sendBloomerRelaunch: (v: { variables: { missionId: string | undefined; month: string } }) => void;
  sendClientRelaunch: (v: { variables: { signingDocumentId?: string | null } }) => void;
  month: Date;
};

const RelaunchButton = (props: {
  type: 'client' | 'bloomer';
  missionId: string;
  relaunches: string[];
  onClick: () => void;
}) => {
  const { type, onClick, relaunches, missionId } = props;
  if (relaunches.includes(missionId))
    return (
      <ActionButton variant="contained">
        <span role="img" aria-label="Déjà relancé">
          ✅
        </span>
      </ActionButton>
    ) as React.ReactNode;

  return (
    <ActionButton
      variant="contained"
      onClick={onClick}
      actionType="Relaunch"
      iconProps={{ sx: { color: type === 'client' ? '#dfeaff' : '#faa3ba' } }}
    />
  ) as React.ReactNode;
};

const CraRelaunchAction = ({
  missionId,
  activityId,
  CRAStatus,
  validated = false,
  billed = false,
  signingDocumentId,
  clientInvoiceStatus,
  sendClientRelaunch,
  sendBloomerRelaunch,
  month,
}: CraRelaunchActionProps) => {
  const relaunches = useMemo<any>(() => [], []);

  switch (CRAStatus) {
    case 'Non crée': {
      const onClickTelephoneRelauch = () => {
        relaunches.push(missionId);
        void sendBloomerRelaunch({
          variables: {
            missionId,
            month: convertDateToStringFormat(lastDateOfMonth(new Date(month))),
          },
        });
      };
      return (
        <RelaunchButton
          type="bloomer"
          onClick={onClickTelephoneRelauch}
          relaunches={relaunches}
          missionId={missionId}
        />
      ) as React.ReactNode;
    }
    case 'Attente signature Client': {
      const onClickWaitingClient = () => {
        relaunches.push(missionId);
        sendClientRelaunch({
          variables: { signingDocumentId: signingDocumentId },
        });
      };
      return (
        <RelaunchButton type="client" onClick={onClickWaitingClient} relaunches={relaunches} missionId={missionId} />
      ) as React.ReactNode;
    }
    case 'Attente signature Bloomer': {
      const onClickWaitingBloomer = () => {
        relaunches.push(missionId);
        sendBloomerRelaunch({
          variables: {
            missionId,
            month: convertDateToStringFormat(lastDateOfMonth(month)),
          },
        });
      };
      return (
        <RelaunchButton type="bloomer" onClick={onClickWaitingBloomer} relaunches={relaunches} missionId={missionId} />
      ) as React.ReactNode;
    }
    case undefined:
    case 'Signature non créee': {
      const onClickBloomer = () => {
        relaunches.push(missionId);
        void sendBloomerRelaunch({
          variables: {
            missionId,
            month: convertDateToStringFormat(lastDateOfMonth(new Date(month))),
          },
        });
      };
      return (
        <RelaunchButton type="bloomer" onClick={onClickBloomer} relaunches={relaunches} missionId={missionId} />
      ) as React.ReactNode;
    }
    default:
      return;
  }
};

export default CraRelaunchAction;
export { CraRelaunchAction as GetAction };
